/** Sample recovery week, shaped like the /recovery/week response.
 *
 * Shown to users with no real logs yet (same idea as the calories/cardio demo cards on
 * the dashboard) so the card isn't an empty shell. No "Demo" badge is rendered anywhere.
 * The first real log replaces it everywhere.
 */
const isoDaysAgo = (n) => {
  const d = new Date();
  d.setDate(d.getDate() - n);
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
};

// Monday-first sample days, so a weekday always shows the same numbers.
const DAY_SAMPLES = [
  { water_ml: 2400, calories: 2180, protein_g: 142, carbs_g: 224, fat_g: 71, meals: 3, sleep_hours: 7.2 },
  { water_ml: 2750, calories: 2320, protein_g: 158, carbs_g: 236, fat_g: 74, meals: 4, sleep_hours: 7.8 },
  { water_ml: 1900, calories: 1960, protein_g: 121, carbs_g: 198, fat_g: 66, meals: 2, sleep_hours: 6.6 },
  { water_ml: 2600, calories: 2410, protein_g: 164, carbs_g: 248, fat_g: 78, meals: 3, sleep_hours: 7.5 },
  { water_ml: 2850, calories: 2275, protein_g: 151, carbs_g: 229, fat_g: 72, meals: 4, sleep_hours: 8.1 },
  { water_ml: 2100, calories: 2520, protein_g: 133, carbs_g: 268, fat_g: 86, meals: 3, sleep_hours: 7.9 },
  { water_ml: 2000, calories: 2040, protein_g: 128, carbs_g: 206, fat_g: 68, meals: 2, sleep_hours: 8.0 },
];

export const DEMO_RECOVERY = {
  has_data: false,
  score: 74,
  read: 'Sleep is carrying this week, hydration is the gap',
  totals: {
    water_ml: 16600,
    avg_calories: 2244,
    avg_protein_g: 142,
    avg_carbs_g: 230,
    avg_fat_g: 74,
    meals: 21,
    avg_sleep_hours: 7.6,
  },
  deltas: { water_ml: 1400, sleep_hours: 0.3 },
  streak: {
    current: 3,
    best: 5,
    today_complete: false,
    today_parts: { water: true, meal: true, sleep: false },
    missing: ['sleep'],
  },
  week: DAY_SAMPLES.map((day, i) => ({ date: isoDaysAgo(6 - i), ...day })),
};

/** Sample totals for one calendar date — nothing for days that haven't happened yet. */
export const demoTotalsFor = (date, today) => {
  if (!date || (today && date > today)) return null;
  const weekday = (new Date(`${date}T00:00:00`).getDay() + 6) % 7; // Monday-first
  return DAY_SAMPLES[weekday];
};

export default DEMO_RECOVERY;
